// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1hYHA","select":"Header_select__1GTRQ","clinic":"Header_clinic__3GkuL"};